export enum GameVariant {
  DEUCES_WILD = "deuces",
  JACKS_OR_BETTER = "jacks",
}
